<template>
    <CardPage :section="14" :page="2">
        <ol>
            <li v-for="(key, index) in tipsOrder" :key="index">
                {{ tips[key].text }}
                <v-textarea outline label="Additional tips" :rows="2" auto-grow v-model="myTips" v-if="'9' === key"></v-textarea>
            </li>
        </ol>
        <p>
            By the way, these are good tips for different types of disclosure, like if you’re living with HIV and want to disclose to a partner.
        </p>
    </CardPage>
</template>

<script>
import { get, sync } from 'vuex-pathify';

export default {
    computed: {
        tips: get('section14/tips'),
        tipsOrder: get('section14/tipsOrder'),
        myTips: sync('section14/tips@9.value')
    }
};
</script>
